import { Container } from 'components/shared';
import { AnimationContainer } from './DotLine';
import { H2, P } from './StyleConstants';
import Image from 'next/image';
import { getAssetUrl } from 'lib/config/assetUrls';
import type { SectionTheme } from './types/bloodVision';
import styles from './HowItWorks.module.css';

const cx = (...classes: (string | undefined)[]) =>
  classes.filter(Boolean).join(' ');

export const HowItWorks = ({
  className,
  htmlId,
  theme = 'light',
}: {
  className?: string;
  htmlId?: string;
  theme?: SectionTheme;
}) => {
  return (
    <section
      className={cx(styles.root, className)}
      id={htmlId}
      data-theme={theme}
    >
      <Container
        style={{
          position: 'relative',
        }}
      >
        <H2 className={styles.heading}>
          Decipher your body&apos;s hidden language
        </H2>
        <P className={styles.para}>
          Blood Vision interprets your biomarkers using advanced research and
          evidence-backed longevity science.
        </P>
        <AnimationContainer />
        <div className={styles.cardContainer}>
          <div className={styles.card}>
            <div className={styles.text}>
              <p className={styles.tag}>STEP 1</p>
              <p className={styles.title}>Schedule your test</p>
              <p className={styles.description}>
                Choose between at-home testing (with a licensed phlebotomist)
                or visit your nearest diagnostics centre.
              </p>
            </div>
            <div className={styles.imgContainer}>
              <Image
                alt="Step 1: Schedule your Blood Vision test at home or a diagnostics centre"
                src={getAssetUrl(
                  `/web_v2/blood-vision/buy/desktop/StepOne_updated.png`,
                )}
                fill
              />
            </div>
          </div>
          <div className={styles.card}>
            <div className={styles.text}>
              <p className={styles.tag}>STEP 2</p>
              <p className={styles.title}>Analyze your results</p>
              <p className={styles.description}>
                Unlock deep insights into your physiology with 100+ biomarkers
                along with a clinician&apos;s summary.
              </p>
            </div>
            <div className={styles.imgContainer}>
              <Image
                alt="Step 2: Analyze your Blood Vision results with 100+ biomarkers"
                src={getAssetUrl(
                  `/web_v2/blood-vision/buy/desktop/StepTwo_updated.png`,
                )}
                fill
              />
            </div>
          </div>
          <div className={styles.card}>
            <div className={styles.text}>
              <p className={styles.tag}>STEP 3</p>
              <p className={styles.title}>Book a follow up test</p>
              <p className={styles.description}>
                A second test reveals how your biomarkers are evolving, giving
                you insight into trends and improvements.
              </p>
            </div>
            <div className={styles.imgContainer}>
              <Image
                alt="Step 3: Book a follow-up test to track biomarker trends"
                src={getAssetUrl(
                  `/web_v2/blood-vision/buy/desktop/StepThree_updated.png`,
                )}
                fill
              />
            </div>
          </div>
        </div>
        {/* <Disclaimer>* At-home testing coming soon</Disclaimer> */}
      </Container>
    </section>
  );
};
